/*
 * File: index.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on April 3, 2025 at 12:20 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 26, 2025 at 9:57 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import { v4 as uuidv4 } from 'uuid';

// Utilities
import { api } from '../api';

// Constants
const { PARSE_MOUNT } = process.env;


/**
 * Services
 */

export const fetchStoryPreviews = ({
	limit,
	tags,
	mediumTypes,
	page
} = {}) => api.post(`${PARSE_MOUNT}/functions/fetchStoryPreviewsWithParameters`, {
	limit,
	tags,
	medium_types: mediumTypes,
	page
});

export const fetchStory = ({
	slug,
	storyId,
	ordinal,
} = {}) => api.post(`${PARSE_MOUNT}/functions/fetchStoryWithParameters`, {
	slug,
	story_id: storyId,
	ordinal
});

export const fetchRelatedStories = ({
	storyId,
} = {}) => api.post(`${PARSE_MOUNT}/functions/fetchRelatedStories`, {
	story_id: storyId
});

export const fetchNextStory = ({
	storyId,
	viewedStories
} = {}) => api.post(`${PARSE_MOUNT}/functions/fetchNextStory`, {
	story_id: storyId,
	viewed_stories: viewedStories
});

export const fetchRandomStory = ({
	storyId,
	viewedStories
} = {}) => api.post(`${PARSE_MOUNT}/functions/fetchRandomStory`, {
	story_id: storyId,
	viewed_stories: viewedStories
});

export const markStoryAsRead = ({
	storyId,
	updateIds,
	performanceConsent
} = {}) => api.post(`${PARSE_MOUNT}/functions/markStoryAsReadWithParameters`, {
	story_id: storyId,
	update_ids: updateIds,
	performanceConsent
});

export const submitStoryUpdate = ({
	title,
	story,
	mediaId,
	artworkArtist,
	artworkCaption,
	hopeMessage,
	healingMessage,
	aControl,
	bControl,
} = {}) => api.post(`${PARSE_MOUNT}/functions/submitStoryUpdateWithParameters`, {
	title,
	story,
	media_id: mediaId,
	artwork_artist: artworkArtist,
	artwork_caption: artworkCaption,
	hope_message: hopeMessage,
	healing_message: healingMessage,
	a_control: aControl,
	b_control: bControl,
});

export const submitStory = ({
	title,
	story,
	mediaId,
	artworkArtist,
	artworkCaption,
	hopeMessage,
	healingMessage,
	email,
	socialAllowed,
	emailAllowed,
	newsletterAllowed,
	tags,
	recaptchaToken,
	publishMainAllowed
} = {}) => api.post(`${PARSE_MOUNT}/functions/submitStoryWithParameters`, {
	title,
	story,
	media_id: mediaId,
	artwork_artist: artworkArtist,
	artwork_caption: artworkCaption,
	hope_message: hopeMessage,
	healing_message: healingMessage,
	email,
	social_allowed: socialAllowed,
	email_allowed: emailAllowed,
	newsletter_allowed: newsletterAllowed,
	tags,
	recaptcha_token: recaptchaToken,
	publish_main_allowed: publishMainAllowed
});

export const fetchSubmission = ({ email, recaptchaToken } = {}) => api.post(`${PARSE_MOUNT}/functions/fetchSubmissionWithParameters`, { email, recaptcha_token: recaptchaToken });

export const uploadStoryMedia = ({ file, onProgress = () => {} }) => {

	// Get file extension
	const dotArray = file.name.split('.');
	const extension = dotArray.slice(dotArray.length - 1).join('.');

	// Create new filename
	const fileName = `${uuidv4()}-${uuidv4()}.${extension}`;

	// Create form data
	const formData = new FormData();
	formData.append('file', file, fileName);

	// Post media
	return api.post('/_api/media/story/create', formData, {
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		onUploadProgress: onProgress
	});
};
